import React, { useEffect, useState } from "react";

import { useDispatch, useSelector } from 'react-redux';
import { useTheme, ThemeProvider, Container, Typography, useMediaQuery, Box, TextField } from "@mui/material";


import SearchIcon from "@mui/icons-material/Search";
import Sidebars from "../../Components/Sidebar/sidebar";
import '../../css/vehicles.css';
import SearchBar from "../../Components/SearchBar";
import { BorderBottom } from "@mui/icons-material";
import appColors from "../../config/appColors";
import { postRequest } from "../../Api";
import { apiRoutes } from "../../Api/apiRoutes";
import { setLoader } from "../../Redux/Reducers/gernalSlice";
import VehicleView from "../../Components/VehicleView";


const TrashVehicles = () => {


  const theme = useTheme();
  const dispatch = useDispatch();

  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));
  const user = useSelector((state) => state.authReducer.user);
  const [activeTab, setActiveTab] = React.useState('dashboard');
  const [vehicles, setVehicles] = useState([]);
  const [tempVehicles, setTempVehicles] = useState([]);


  const getTrash = async () => {

    const onSuccess = (res) => {
      setVehicles(res.data?.reverse());
      setTempVehicles(res.data?.reverse());
    }

    const onError = (err) => {
      console.log('err', err);
    }

    dispatch(setLoader(true));
    const body = {
      token:  user?.token
    }

    await postRequest(body, apiRoutes.getDeletedVehicles, onSuccess, onError)

  }




  useEffect(() => {
    getTrash();
  }, [])


  return (
    <>
      <ThemeProvider theme={theme}>
        <div style={{ display: 'flex', }}>
          <Sidebars />

          <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 20, width: "75%" }} >
            <span className={`headertext ${isSmallScreen ? 'small-screen' : ''}`}>
              Deleted Vehicles
            </span>
           
            <div style={{ display: 'flex', marginTop: 20, width: "100%", flexWrap: 'wrap', }}>
              {
                vehicles.map((item, index) => (
                  <VehicleView key={index} vehicle={item} style={{ marginBottom: 20 }} />
                ))
              }
            </div>

          </div>
        </div>
      </ThemeProvider>
    </>
  )

}



const tabContainer = {
  display: 'flex',
  flexDirection: 'row',
  backgroundColor: 'white',
  width: "40%",
  borderRadius: 15,
  paddingTop: 10, paddingRight: 20, paddingLeft: 20,
  justifyContent: 'space-between',
  boxShadow: '0px 4px 4px rgba(31, 31, 31, 0.1)',


}
const tabText = {
  fontSize: 14,
  color: '#000000',
  fontFamily: 'Poppins',


}

const focusedTabLine = {
  backgroundColor: appColors.primary,
  width: 55,
  height: 2,
  marginTop: 5

}

// const searchBarContainer = {
//   display: 'flex',
//   flexDirection: 'row',
//   width: '30%',
//   // marginTop: 20,
//   marginLeft: 20,
//   borderRadius: 15,
//   paddingLeft: 10,
//   paddingRight: 10,
//   paddingTop: 10,
//   paddingBottom: 10,
//   backgroundColor: appColors.white,
//   boxShadow: '0px 4px 4px rgba(31, 31, 31, 0.1)',
//   height: 25,



// }



export default TrashVehicles
